export const SEGMENT_STATUSES = ["Active", "Planned", "Inactive"] as const;

export type SegmentStatus = (typeof SEGMENT_STATUSES)[number];

export const SEGMENT_STATUS_CONFIG: Record<
  SegmentStatus,
  { labelKey: string; variant: "success" | "info" | "neutral" }
> = {
  Active: { labelKey: "common.active", variant: "success" },
  Planned: { labelKey: "common.planned", variant: "info" },
  Inactive: { labelKey: "common.inactive", variant: "neutral" },
};

/**
 * Every segment event on the `client:` channel (`RealtimeEvents.Segment` on the backend: created, updated,
 * membership-changed). The overview shows all of a segment's data, so any of them refreshes all of it.
 */
export const SEGMENT_REALTIME_EVENTS = "segment:*";
